import { ApiClientError } from '../../../../api/httpClient';
import { DeletionJob, ProtectionReason, VersionState } from './versionTypes';
export const versionStateLabels: Record<VersionState['state'], string> = {
  uploading: 'Файлы ещё загружаются', available: 'Версия доступна', deleting: 'Версия удаляется', deleted: 'Версия удалена', protected_unknown: 'Состояние версии неизвестно',
};
export const protectionLabels: Record<ProtectionReason, string> = {
  current_version: 'Эта версия используется опубликованной картой и защищена от удаления.',
  current_unavailable: 'Не удалось проверить опубликованную карту. Удаление недоступно.',
  coordination_unconfigured: 'Безопасное управление версиями ещё не настроено.',
  operation_active: 'Другая операция выполняется или требует проверки оператором.',
  unknown_version: 'Нет подтверждённых сведений об этой версии. Удаление недоступно.',
  upload_incomplete: 'Загрузка этой версии ещё не завершена.',
  tombstoned: 'Версия уже удаляется или удалена. Повторное удаление недоступно.',
  not_retired: 'Замена этой версии ещё не подтверждена.',
  clock_unavailable: 'Не удалось достоверно проверить срок хранения. Удаление недоступно.',
  retention_pending: 'Обязательный срок хранения после замены ещё не истёк.',
};
export const deletionStatusLabels: Record<DeletionJob['status'], string> = {
  queued: 'Удаление в очереди', running: 'Удаление выполняется', succeeded: 'Удаление завершено', failed: 'Удаление не выполнено', recovery_required: 'Удаление требует проверки оператором',
};
export function versionErrorCopy(error: unknown): string {
  if (!(error instanceof ApiClientError)) return 'Не удалось подтвердить результат. Проверьте подключение и обновите данные. Новый запрос удаления не создаётся автоматически.';
  const code = error.errors.deletion?.[0] ?? error.errors.version?.[0];
  switch (code) {
    case 'management_unconfigured': case 'deletion_disabled': case 'deletion_unavailable': case 'deletion_unready': return 'Удаление пока недоступно. Обратитесь к администратору сервиса.';
    case 'current_unavailable': return protectionLabels.current_unavailable;
    case 'operation_active': return protectionLabels.operation_active;
    case 'current_version': return protectionLabels.current_version;
    case 'retention_pending': return protectionLabels.retention_pending;
    case 'clock_unavailable': return protectionLabels.clock_unavailable;
    case 'idempotency_conflict': return 'Этот запрос нельзя безопасно повторить. Требуется проверка оператором.';
    default: return 'Не удалось проверить или удалить версию. Обновите данные; если доступ ограничен, обратитесь к администратору.';
  }
}
